import Storage from "@/utils/storage";
import Vue from "vue";
import Vuex from "vuex";

function initToken() {
    let t = Storage.getToken();
    if (!t) {
        var search = window.location.search;
        var m = search.match(/(?:[?&])jwt=([^&]*)/);
        if (m) {
            t = decodeURIComponent(m[1]);
            if (t) {
                var time = new Date(new Date() * 1 + 2 * 60 * 60 * 1000);
                Storage.setItem("jwt", t, { expires: time });
                var cleanUrl = window.location.href.replace(/([?&])jwt=[^&]*&?/g, function (match, p1) {
                    return match.slice(-1) === "&" ? p1 : "";
                });
                window.history.replaceState(null, "", cleanUrl);
            }
        }
    }
    return t || "";
}

let jwt = initToken();

let cookieId = Storage.getItem("cookieId");

if (!cookieId) {
    cookieId = "";
}

Vue.use(Vuex);

const SET_JWT = "SET_JWT";

// 2小时失效
function expirationTime() {
    return new Date(new Date() * 1 + 2 * 60 * 60 * 1000);
}

export default new Vuex.Store({
    state: {
        jwt: jwt,
        cookieId: cookieId,
    },
    mutations: {
        [SET_JWT](state, payload) {
            state.jwt = payload;
        },
    },
    actions: {
        setToken({ commit }, payload) {
            const time = expirationTime()
            Storage.setItem("jwt", payload, { expires: time });
            commit("SET_JWT", payload);
        },
    },
    modules: {},
});
